<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <div>

    <!-- TABLA POR TRATAMIENTO-->
    <div >
      <b-row class="text-center pl-3 pr-4">
        <b-col cols="4" class=" text-left" :class="existeCardActiva ? 'textoActivo' : 'thtable'" style="padding-left: 22px;">Tratamiento</b-col>
        <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'">Diente</b-col>
        <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'" v-if="existePlan || aplicaPromocionesTx">Subtotal</b-col>
        <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'" v-if="existePlan">Descuento de plan</b-col>
        <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'" v-if="aplicaPromocionesTx">Descuento promo</b-col>
        <b-col class="thtable" :class="existeCardActiva ? 'textoActivo' : 'thtable'">Inversion total</b-col>
        <b-col cols="1" class="thtable"></b-col>
      </b-row>
      <hr style="margin-top: 3px; border: 0; height: .1vh; background: #D6E7F3;">
      <div class="scrollable-container no-horizontal-scroll">
        <div v-for="(me, index) in tratamientosPrioridad.filter(tp => tp.clasificacion === 1)" :key="index">


        <b-card :class="cardSeleccionado === index ? 'cardSe seleccionado' : 'cardCerrada'" class="mt-2 mb-1" v-if="me.tratamientos.length > 0">
          <b-row class="text-center">
            <b-col cols="4" :class="cardSeleccionado === index ? 'cardSeTitle seleccionado' : 'cardSeTitle'"
                   style="font-size: 9px; width: 34.5%;"
                   class="text-left pr-0">
             <div class="d-flex">
              <em v-if="me.idKitTratamiento == null" class="dienteCepillo" style="margin-top: -7%;"></em>
              <em v-else class="kit_svg" style="margin-top: -7%;"></em>
              <p v-if="me.idKitTratamiento == null">{{ me.tratamiento }}</p>
              <p v-else>{{ me.nombreKit }}</p>
              <em v-if="me.tieneArgumentario" v-b-tooltip.hover.topleft.v-light
                  title="Ver argumentario"
                  class="info_padecimiento"
                  style="position: relative !important; margin-bottom: -3px; cursor: pointer; width: 12px;
"
                  @click="verArgumentario(me.nombreKit == null ? me.idTratamiento : null, me.nombreKit == null ? me.tratamiento : me.nombreKit, me.nombreKit == null ? [] : me.tratamientos)"></em>
             </div>
            </b-col>

            <b-col class="leterSize">
              <div v-if="me.idKitTratamiento === null "> {{ me.dientesAgrupados.toString() }}</div>
              <div v-else > {{ me.tratamientos.filter(t => t.clasificacion === 1)[0].diente }}</div>
            </b-col>
            <b-col class="leterSize" v-if="existePlan || aplicaPromocionesTx">
              <div>{{ me.subtotal | monedaEntero }}</div>
            </b-col>
            <b-col class="leterSize" v-if="existePlan">
              <div>{{ me.descuentoPlan | monedaEntero }}</div>
            </b-col>
            <b-col class="leterSize" v-if="aplicaPromocionesTx">
              <div v-if="me.idKitTratamiento == null">
                <TagPromocionV5 v-if="me.promocion == null "
                                :promociones.sync="promociones"
                                :tratamiento.sync="me"
                                :totalPrioridadClinica.sync="cantidadtotalPrioridad"
                                @restarPromocionAplicada="restarPromocionAplicada"
                                :agrupadoPorOd="false"
                ></TagPromocionV5><!---->
                <span v-if="me.promocion != null">
                            <p> <span v-b-tooltip.hover.lefttop.v-light
                                      :title="me.promocion.promocion"
                                      style="cursor: pointer"
                            >{{ me.descuentoPromo | monedaEntero }} </span>
                              <em v-if=" me.promocion.promocionForzosa === false "
                                  style="cursor: pointer"
                                  v-b-tooltip.hover.lefttop.v-light
                                  title="Quitar promoción"
                                  class="quitarPromo" @click="quitarPromo(me, false)"
                              ></em>
                            </p>
                      </span>
              </div>
              <div v-else>
                {{me.descuentoPromo | monedaEntero}}
              </div>
            </b-col>
            <b-col class="leterSize">
              <div>{{ me.inversionTotal | monedaEntero }}</div>
            </b-col>
            <b-col class="d-flex justify-content-end p-0" cols="1">
              <div>
                <em v-if="!me.agregadoACarrito && me.tratamientos.filter(t => t.banderaMovimientosHallPrio > 0 ).length > 0 "
                    class="startCircle" style="width: 18px; cursor: pointer; margin-left: -6px;"
                    v-b-tooltip.hover.top.v-light
                    title="Enviar a hallazgos adicionales"
                    @click="clasificarPorHallazgo(me)"
                ></em> <!--Grupo de tratamientos, Especialmente por kits-->

                <em v-if="!me.agregadoACarrito && me.tratamientos.filter(c => c.agregadoACarrito && c.clasificacion === 1).length === 0"
                    class="carritoAzul ml-3" style="width: 20px; cursor: pointer"
                    v-b-tooltip.hover.top.v-light
                    title="Agregar al carrito"
                    @click="agregarACarrito(me, true, me)"

                ></em>

                <b-button v-if="cardSeleccionado === index" pill size="sm" variant="outline-ligth"
                          @click="deseleccionarCard"
                          :id="'chevron-'+index" :key="'chevron-'+index" v-b-toggle="'collapseDetail-'+index"
                          style="margin-top: -12px;"
                >
                  <b-icon
                      style="color: #4FB0B7;  font-size: 10px; height: 14px"
                      icon="chevron-up"
                  ></b-icon>
                </b-button>
                <b-button v-else pill size="sm" variant="outline-light" @click="seleccionarCard(me.tratamientos, index)"
                :class="{'ml-2': me.agregadoACarrito}"
                          :id="'chevron-'+index" :key="'chevron-'+index" v-b-toggle="'collapseDetail-'+index"
                          style="margin-top: -12px;"
                          
                >
                  <b-icon
                      style="color: #4FB0B7;  font-size: 10px; height: 14px"
                      icon="chevron-down"
                  ></b-icon>
                </b-button>
              </div>
            </b-col>
          </b-row>

          <b-collapse :id="'collapseDetail-'+index" class="mt-1" accordion="my-accordion-detalle" role="tabpanel">
            <div class="p-3" style="border: 1px solid #F3F3F3; border-radius: 20px;">
              <div class="row text-center" style="max-height: 30px">
                <div class="col-3 d-flex justify-content-center align-items-center" style="border-right: 1px solid #DBDBDB; max-height: 30px">
                  <p class="mt-3 headerTxt">Od's afectados</p>
                </div>
                <div class="col ml-3 d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px" v-if="me.tratamientos.filter(t => t.clasificacion === 1)[0].idKitTratamiento !== null">
                    <p class="mt-3 headerTxt">Tratamiento</p>
                </div>
                <div class="col ml-3 d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                  <p class="mt-3 headerTxt">Cantidad</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="mt-3 headerTxt">Precio unitario</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px"
                     v-if="existePlan || aplicaPromocionesTx" >
                    <p class="mt-3 headerTxt">Subtotal</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px"
                     v-if="existePlan" >
                  <p class="mt-3 headerTxt">Descuento plan</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px"
                     v-if="aplicaPromocionesTx" >
                  <p class="mt-3 headerTxt">Descuento promo</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center mr-2" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                  <p class="mt-3 headerTxt">Total</p>
                </div>
              </div>
              
              <div class="" v-for="(lista, index1) in me.tratamientos.filter(t => t.clasificacion === 1)" :key="index1">
                <b-row class="text-center">
                  <b-col cols="3" class="pt-2 d-flex justify-content-center" style="border-right: 1px solid #DBDBDB;">
                    <em v-if="!lista.agregadoACarrito && lista.idKitTratamiento == null"
                          class="carritoAzul" style="width: 18px; cursor: pointer; margin-right: 4px;"
                          v-b-tooltip.hover.top.v-light
                          title="Agregar al carrito"
                          @click="agregarACarrito(lista, false, me)"
                      ></em> 
                      <em v-if="lista.banderaMovimientosHallPrio > 0 && lista.idKitTratamiento == null"
                          class="startCircle" style="width: 15px;margin-right: 8px; cursor: pointer"
                          v-b-tooltip.hover.top.v-light
                          title="Enviar a hallazgos adicionales"
                          @click="enviarIndividualAHallazgo(lista, me, false, index1)"
                      ></em>
                    <div v-if="index1 == 0 && lista.idKitTratamiento !== null"
                          class="d-flex justify-content-center align-items-center p-0" style="border: 1px solid #B9D7EC; border-radius: 20px; min-height: 35px; min-width: 70%">
                        <p class="m-0 bodyTxt" style="font-weight: 600" >{{ lista.diente }}</p>
                    </div>
                    <div v-if="lista.idKitTratamiento == null"
                         class="d-flex justify-content-center align-items-center p-0" style="border: 1px solid #B9D7EC; border-radius: 20px; min-height: 35px; min-width: 70%">
                      <p class="m-0 bodyTxt" style="font-weight: 600" >{{ lista.diente }}</p>
                    </div>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center ml-3 mt-2" v-if=" lista.idKitTratamiento !== null ">
                    <p class="m-0 bodyTxt">{{ lista.tratamiento }}</p>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center ml-3 mt-2">
                    <p class="m-0 bodyTxt">{{ lista.cantidadMaxima }}</p>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center mt-2">
                    <p class="m-0 bodyTxt">{{ lista.precioUnitario | moneda}}</p>
                  </b-col>

                  <b-col v-if="existePlan || aplicaPromocionesTx" class="d-flex justify-content-center align-items-center mt-2">
                    <p class="m-0 bodyTxt">{{ lista.subtotal | moneda}}</p>
                  </b-col>

                  <b-col class="d-flex justify-content-center align-items-center mt-2" v-if="existePlan">
                    <div>
                      <p class="m-0 bodyTxt">{{ (lista.montoDescuentoUnitario) | moneda}}</p>
                      <div
                          v-for="(item, index) in lista.lstCalcDesc"
                          :key="index"
                      >
                        <strong v-if="item.tipoDescuentoPlan === 'PORCENTAJE'" style="font-size: 0.60rem;" class=" text-muted">
                          <span   v-if="item.idPlanValePaciente !== null "> ({{index+1}}) {{ item.porcentajeDescuentoPlan}}% : {{ item.montoDescuentoVale | moneda}}</span>
                          <span  v-else> ({{index+1}}) {{ item.porcentajeDescuentoPlan}}% : {{ item.montoDescuentoPlan | moneda}}</span>
                        </strong>
                        <strong v-if="item.tipoDescuentoPlan === 'MONTO'" style="font-size: 0.60rem;" class=" text-muted">({{index+1}}) MONTO DESCUENTO: {{ item.montoDescuentoPlan | moneda}}</strong>
                      </div>
                    </div>
                  </b-col>

                  <b-col v-if="aplicaPromocionesTx && lista.idKitTratamiento !== null" class="d-flex justify-content-center align-items-center mt-2">
                    <TagPromocionV5 v-if="lista.promocion === null"
                                    :promociones.sync="promociones"
                                    :tratamiento.sync="lista"
                                    :totalPrioridadClinica.sync="cantidadtotalPrioridad"
                                    @restarPromocionAplicada="restarPromocionAplicada"
                                    :agrupadoPorOd="false"
                    ></TagPromocionV5>
                    <p v-if="lista.promocion !== null" class="m-0 bodyTxt" :title="lista.promocion != null ? lista.promocion.idPromocion+'-'+lista.promocion.promocion:''">
                      {{ lista.descuentoPromo | moneda}}
                    </p>
                    <p v-else class="m-0 bodyTxt"> $0</p>
                    <em v-if="lista.promocion !== null && lista.promocion.promocionForzosa === false "
                        style="cursor: pointer"
                        v-b-tooltip.hover.lefttop.v-light
                        title="Quitar promoción"
                        class="quitarPromo" @click="quitarPromo(lista, false)"
                    ></em>
                  </b-col>
                  <b-col v-if="aplicaPromocionesTx && lista.idKitTratamiento === null" class="d-flex justify-content-center align-items-center mt-2"
                         :title="lista.promocion != null ? lista.promocion.idPromocion+'-'+lista.promocion.promocion:''">
                    <p v-if="lista.promocion !== null" class="m-0 bodyTxt">{{ lista.promocion.promoDescPesos | moneda}}</p>
                    <p v-else class="m-0 bodyTxt"> $0</p>
                  </b-col>

                  <b-col class="d-flex flex-column justify-content-center align-items-center mt-2 mr-2">
                    <p class="m-0 bodyTxt">
                      {{ calcularSubtotal(lista, me) | moneda }}<br>
                      <span
                          v-for="(item, index) in lista.lstCalcDesc"
                          :key="index"
                      >
                    <strong v-if="item.tipoDescuentoPlan == 'COPAGO'" style="font-size: 0.60rem;" class=" text-muted">({{index+1}}) COPAGO FIJO: {{ item.montoCopagoFijo | moneda}}</strong><br>
                        </span>
                    </p>
                  </b-col>




                </b-row>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </div>
      <div class="d-flex justify-content-between mt-2 mb-2">
        <b-button pill variant="outline-info" size="sm"
                    v-if="idEtapaAnterior !== 101 && idEtapa != 97"
                    @click="rechazarParaEdicion()"
                  :disabled="loading"
                  
          >
            <span style="font-size: 11px">Volver a editar</span>
            <b-spinner v-if="loading" small></b-spinner>
          </b-button>
          <div v-else></div>
          <div>
            <span class="text-2">Total de prioridad clínica: </span>
            <span class="text-3"> {{cantidadtotalPrioridad | monedaEntero}}</span>
          </div>
        </div>
      </div>
    </div>


  </div>

    <b-modal
        size="lg"
        v-model="mostrarArgumentarioTx"
        scrollable
        hide-footer
        hide-header
    >
      <div style="display: flex;width: 100%;" class="mb-3">
        <div class="d-flex align-items-center detalle-formulario">
                <span class="detalle-formulario-h1 ml-3"
                      style="font-size: 20px; font-weight: bolder !important; color: var(--color-dentalia) !important;">
                Argumentario: {{datosArgumentarioTx.nombreTx}}
                </span>

        </div>
        <b-button class="button-dentalia-svg-4 mr-2" variant="primary"
                  @click="mostrarArgumentarioTx = false">
          <em class="close_x_svg icon-dentalia-svg-0" style="height: 16px; "></em>
        </b-button>
      </div>

      <ModalArgumentario v-if="mostrarArgumentarioTx"
                         :idTratamiento="datosArgumentarioTx.idTx"
                         :nombreTratamiento="datosArgumentarioTx.nombreTx"
                         :listaTrtConArgumentario="datosArgumentarioTx.listaTrtConArgumentario"/>
    </b-modal>
  </div>
</template>

<script>
import TagPromocionV5 from "@/version5/TagPromocionV5";
import ModalArgumentario from "@/views/argumentario/ModalArgumentario.vue";


export default {
  name: "TablaPrioridadClinica",
  components: {
    ModalArgumentario,
    TagPromocionV5,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    existeCardActiva: false,
    loading: false,
    cardSeleccionado: null,
    tratamientos: [],
    mostrarArgumentarioTx: false,
    datosArgumentarioTx: {
      idTx: null,
      nombreTx: null
    },
    montoAhorrado: 0,
    cantidadtotalPrioridad: 0,
    idEtapa: null,
  }),
  props: {
    presuntivoSeleccionado: Number,
    tratamientosPrioridad: Array,
    totalPrioridadClinica: Number,
    promociones:Array,
    tratamientosPrioridadPorOD: Array,

    idPti: Number,
    idSolicitudEtapa: Number,
    idSolicitud: Number,
    aplicaPromocionesTx: Boolean,
    nombrePlan: String,
    existePlan: Boolean,
    idEtapaAnterior: Number
  },
  watch:{
    totalPrioridadClinica(){
      this.cantidadtotalPrioridad = this.tratamientosPrioridad.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
      this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)
    }

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idEtapa = this.$route.params.idEtapa;
  },
  methods: {
    calcularSubtotal(lista, me) {
      let subtotal = lista.montoUnitarioDespuesDePlanPromo -
          (lista.descuentoPromo == null ? 0 : lista.descuentoPromo);

      if (subtotal < 0) {
        subtotal = 0;
      }

         me.montoAceptadoInversion = me.tratamientos.filter(t => t.agregadoACarrito ).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.total;
        }, 0);
         
      this.$emit('agregarAResumenInversion');
      return subtotal;
    },
    clasificarPorHallazgo(item){
      console.log("item", item)
      item.clasificacion = 2
      item.tratamientos.forEach(i => i.clasificacion = 2)

      this.$emit('enviarGrupoAHallazgo', item)

      this.cantidadtotalPrioridad = this.tratamientosPrioridad.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
      this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)
    },
    enviarIndividualAHallazgo(tratamiento, tPadre, esPorOd, index){
      if (tratamiento.agregadoACarrito){
        this.$swal.fire({
          icon: "error",
          html: '<div style="text-align:center;font-weight: 600; font-size: small">No se puede enviar a hallazgos, ' +
              'el tratamiento esta agregado en el carrito </div> <br>',
        });
      }else {


        this.$emit('enviarIndividualAHallazgo', tratamiento, tPadre)


        tratamiento.clasificacion = 2;
        this.cantidadtotalPrioridad = this.cantidadtotalPrioridad - tratamiento.total;
        this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)

        this.cantidadtotalPrioridad = this.tratamientosPrioridad.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
          return vAnterior + vActual.inversionTotal;
        }, 0);
        this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)


        if (esPorOd) {
          this.tratamientosPrioridad.forEach(tp => {
            if (tp.idTratamiento === tratamiento.idTratamiento) {
              let indexTx = tp.tratamientos.findIndex(t => t.idPtiTratamiento === tratamiento.idPtiTratamiento)
              tp.tratamientos.splice(indexTx,1)
            }
          })
        }

        console.log(tPadre.tratamientos, index)
        console.log(tPadre,  "Que es tPadre ??? ")


      }

    },
    recalcularPorHallazgos(){
      this.cardSeleccionado = null;
      this.existeCardActiva = true;
       this.cantidadtotalPrioridad = this.tratamientosPrioridad.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
         return vAnterior + vActual.inversionTotal;
       }, 0);
      this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)
    },
   /* recalcularPorHallazgosOD() {
      this.cantidadtotalPrioridad = this.tratamientosPrioridadPorOD.reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
    },*/
    quitarPromo(item){
      this.$emit('montosByRetiroPromo', item)

      if (item.idKitTratamiento == null){
        item.inversionTotal += item.promocion.promoDescPesos;
        let descPromo = 0
        item.tratamientos.forEach(t => {
          if (t.promocion != null){
            t.total += t.promocion.promoDescPesos;
            t.promocion = null
            t.descuentoPromo = 0;
          }
          descPromo += t.descuentoPromo;
        })
        item.promocion = null;
        item.descuentoPromo = descPromo;


      }
      this.cantidadtotalPrioridad =0;
      this.cantidadtotalPrioridad = this.tratamientosPrioridad.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
        return vAnterior + vActual.inversionTotal;
      }, 0);
      this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)

    },

    /*,*/

    restarPromocionAplicada( tratamiento, descuentoOd, dioClick){

      if (descuentoOd){//se ejecuta por agrupacion od
        this.$emit("montoAhorradoPromoByOD", tratamiento);

        this.cantidadtotalPrioridad = this.tratamientosPrioridadPorOD.reduce((vAnterior, vActual) => {
          return vAnterior + vActual.inversionTotal;
        }, 0);
        this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)


      } else {//se ejecuta por agrupacion tratamiento


        this.cantidadtotalPrioridad = this.tratamientosPrioridad.filter(t => t.clasificacion === 1).reduce((vAnterior, vActual) => {
          return vAnterior + vActual.inversionTotal;
        }, 0);
        this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)


        this.$emit('montoAhorradoByPromocion', dioClick, tratamiento);
      }

    },

    reCostearPrioridadByKits(costoPrioridad){
      this.cantidadtotalPrioridad = costoPrioridad;
      this.$emit("cantidadTotalPrioridad", this.cantidadtotalPrioridad)
      
    },

    rechazarParaEdicion(){
      this.$swal.fire({
        icon: "warning",
        html: '<div style="text-align:center;font-weight: 600; font-size: small">Enviar a edición de diagnóstico</div> <br>' +
            '<div style="text-align:center; font-size: small">Este PTI se enviará a edición de diagnóstico y no estará disponible para negociar ' +
            'hasta que se termine de editar, ¿desea continuar?</div>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        confirmButtonColor: "#EEBA6D",
        cancelButtonColor: "#dfdfdf",
        customClass: {
          confirmButton: "rounded-pill text-small",
          cancelButton: " rounded-pill text-small text-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          const params = {
            idTipoRechazo: 6,
            idPti: this.idPti,
            idSolicitudFlujo: this.idSolicitudEtapa,
            idSolicitud: this.idSolicitud,
            idEtapa: this.$route.params.idEtapa
          }
          this.$http.put(this.$api + "procesoPtiV5/rechazarPti", params).then(resp => {
            if (resp.data.data){
              this.loading = false;
              this.$swal.fire({
                icon: "success",
                html: '<div style="text-align:center;font-weight: 600; font-size: small">PTI enviado a diagnóstico exitosamente</div> <br>',
                focusConfirm: true,
                showCancelButton: false,
                confirmButtonText: "Cerrar",
                confirmButtonColor: "#dfdfdf",
                customClass: {
                  confirmButton: "rounded-pill text-small border-secondary text-secondary",
                },
              });
            }
          }).finally(() => {
            this.$router.push('/bandejaEmbajadorHallazgoV5');
          })
        }
      });
    },

    agregarACarrito(me, porGrupoTratamientos, mePadre){

      if (porGrupoTratamientos) {
        if (me.promocion != null){
           me.tratamientos.forEach(t => {
            /*
            * Cannot read properties of null (reading 'promoDescPesos')
            * Para evitar este error de front, validamos que t.promocion !== null */
            if (t.promocion !== null){
              t.descuentoPromo = t.promocion.promoDescPesos;
            }
          })
        }
        me.agregadoACarrito = true;
        me.tratamientos.forEach(t => {
          t.agregadoACarrito = true;
          t.cantidadAceptada = t.cantidadMaxima;
        });
      }else {
        let total = 0;
        mePadre.agregadoACarrito = true;
        mePadre.tratamientos.forEach(tp=>{
          if(tp.idPtiTratamiento === me.idPtiTratamiento){
            tp.agregadoACarrito = true;
            tp.cantidadAceptada = tp.cantidadMaxima;
          }
          if (tp.agregadoACarrito){
            total =tp.total+total;
          }
        })
        mePadre.montoAceptadoInversion =total;
        me.descuentoPromo = me.promocion != null ? me.promocion.promoDescPesos : 0;

      }

      this.$emit('agregarAResumenInversion')

        //this.$emit('agregarAResumenInversion', me, porGrupoTratamientos)
      mePadre.dientesAgrupadosCarrito = [];
        mePadre.tratamientos.forEach(p => {
          if (p.agregadoACarrito) {
            mePadre.dientesAgrupadosCarrito.push(p.diente)
          }
        })



    },

    verArgumentario(idTx, nombre, kit){
      if(kit.length > 0){
        kit.forEach((k,i)=>{
          k.seleccionado = i === 0;
          k.nombreTratamiento = k.tratamiento;
        })
        kit = kit.filter(k=>k.argumentarioCompleto);
      }
      this.datosArgumentarioTx.idTx = kit.length > 0 ? kit[0].idTratamiento : idTx;
      this.datosArgumentarioTx.nombreTx =  nombre;
      this.datosArgumentarioTx.listaTrtConArgumentario = kit;
      this.mostrarArgumentarioTx = true;
    },


    seleccionarCard(tratamientos, index) {
      this.$emit("dientesSeleccionados", tratamientos);
      this.cardSeleccionado = index;
      this.existeCardActiva = true;
    },
    deseleccionarCard() {
      this.$emit("dientesSeleccionados", []);
      this.cardSeleccionado = null;
      this.existeCardActiva = false;
    }
  }
}
</script>

<style scoped>
.txSinAcciones{
  min-width: 100%
}

.txConAcciones{
  min-width: 76%
}

.textoActivo{
  font-size: .7em !important;
  font-weight: bolder;
  color: #BFBFBF;
}

.agregadoCarrito{
  color: #4FB0B7;
  font-weight: 600;
}

.scrollable-container {
    overflow-y: auto; 
    min-height: 55vh;
  }

.cardSe {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
  min-height: 60px;
}

.cardCerrada {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
  height: 60px;
}

.cardSe.seleccionado {
  border-style: solid;
  border-width: 2px;
  border-color: #90d3dd;
  border-radius: 16px;
}
.cardSeTitle.seleccionado{
  font-weight: 600;
  font-size: 12px !important;
}
.cardSeTitle{
  font-size: .75em !important;
}
.leterSize{
  font-size: .75em !important;
  color: #4F4F4F;
}
.headerTxt{
  font-size: .8em;
  color: #4F4F4F;
  font-weight: 600;
}
.bodyTxt{
  font-size: .8em;
  color: #747474;
}
.thtable {
  font-size: .7em !important;
  font-weight: bolder;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgb(0 0 0 / 0%);
}
.text-2 {
  position: relative;
  color: #000000;
  font-size: 11px;
  font-weight: 600;
  line-height: 17.332px;
  text-align: center;
}
.text-3 {
  position: relative;
  color: #0069a9;
  font-size: 11px;
  font-weight: 600;
  line-height: 17.332px;
  text-align: center;
}
.table th, .table td {
  padding: 0.2rem;
  vertical-align: middle;
  border-top: 0px solid #ffffff;
  font-size: 12px;
}
</style>
